import { jsx as _jsx } from "react/jsx-runtime";
import RcSlider from 'rc-slider';
import { RcSliderStyle } from './styles';
import 'rc-slider/assets/index.css';
RcSlider.displayName = 'RcSlider';
export var Slider = function (_a) {
  var min = _a.min,
    max = _a.max,
    value = _a.value,
    onChange = _a.onChange,
    onAfterChange = _a.onAfterChange;
  return _jsx(RcSliderStyle, {
    children: _jsx(RcSlider, {
      min: min,
      max: max,
      value: value,
      onChange: onChange,
      onAfterChange: onAfterChange,
      handleStyle: {
        height: '24px',
        width: '24px',
        marginTop: '-10px'
      }
    })
  });
};
Slider.displayName = 'Slider';